var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9161 1.9043H22.2896L14.9196 10.3278L23.5898 21.7903H16.8011L11.4839 14.8383L5.39979 21.7903H2.02428L9.90728 12.7804L1.58984 1.9043H8.55095L13.3572 8.25863L18.9161 1.9043ZM17.7322 19.7711H19.6014L7.53524 3.81743H5.52931L17.7322 19.7711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.43f82fc2c302523d0aa3412d1de86ea6.svg";
export { ForwardRef as ReactComponent };